"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseTable = void 0;

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _vuePropertyDecorator = require("vue-property-decorator");

var _tableHead = require("./tableHead");

var _colGroup = require("./colGroup");

var _tableBodyRow = require("./tableBodyRow");

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function transColumns2TableBodyColumns(columns) {
  var parentDataIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var result = [];
  columns.forEach(function (col) {
    if (col.children) {
      result.push.apply(result, (0, _toConsumableArray2.default)(transColumns2TableBodyColumns(col.children, col.dataIndex ? [].concat((0, _toConsumableArray2.default)(parentDataIndex), [col.dataIndex]) : parentDataIndex)));
      return;
    }

    if (parentDataIndex.length) {
      result.push(_objectSpread(_objectSpread({}, col), {}, {
        dataIndex: col.dataIndex ? [].concat((0, _toConsumableArray2.default)(parentDataIndex), [col.dataIndex]).join('.') : undefined
      }));
      return;
    }

    result.push(col);
  });
  return result;
}

var BaseTable = (_dec = (0, _vuePropertyDecorator.Component)({
  components: {
    TableHead: _tableHead.TableHead,
    TableBodyRow: _tableBodyRow.TableBodyRow,
    ColGroup: _colGroup.ColGroup
  }
}), _dec2 = (0, _vuePropertyDecorator.Inject)(), _dec3 = (0, _vuePropertyDecorator.Prop)(), _dec4 = (0, _vuePropertyDecorator.Prop)({
  default: true
}), _dec5 = (0, _vuePropertyDecorator.Prop)({
  default: true
}), _dec6 = (0, _vuePropertyDecorator.Prop)(), _dec7 = (0, _vuePropertyDecorator.Prop)(), _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(BaseTable, _Vue);

  var _super = _createSuper(BaseTable);

  function BaseTable() {
    var _this;

    (0, _classCallCheck2.default)(this, BaseTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _initializerDefineProperty2.default)(_this, "table", _descriptor, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "fixed", _descriptor2, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "hasHead", _descriptor3, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "hasBody", _descriptor4, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "scroll", _descriptor5, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "footer", _descriptor6, (0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(BaseTable, [{
    key: "columns",
    get: function get() {
      var fixed = this.fixed,
          table = this.table;

      if (!fixed) {
        return table.columns;
      }

      return fixed === 'left' ? table.tableBodyFixedLeftColumns : table.tableBodyFixedRightColumns;
    }
  }, {
    key: "tableBodyColumns",
    get: function get() {
      return transColumns2TableBodyColumns(this.columns);
    }
  }, {
    key: "handleRowHover",
    value: function handleRowHover(isHover, key) {
      this.table.tableStore.currentHoverKey = isHover ? key : null;
    }
  }, {
    key: "renderTableBody",
    value: function renderTableBody() {
      var _this2 = this;

      var h = this.$createElement;
      var table = this.table,
          footer = this.footer,
          handleRowHover = this.handleRowHover,
          fixed = this.fixed;
      var rowKey = table.rowKey,
          tableStore = table.tableStore;
      var rows = (footer ? [table.footerData] : table.dataSource).map(function (record, index) {
        var key = typeof rowKey === 'function' ? rowKey(record, index) : record[rowKey];
        return h("table-body-row", {
          "key": key,
          "attrs": {
            "rowKey": key,
            "record": record,
            "index": index,
            "columns": _this2.tableBodyColumns,
            "hovered": tableStore.currentHoverKey === key,
            "fixed": fixed
          },
          "on": {
            "hover": handleRowHover
          }
        });
      });
      return h("tbody", {
        "class": "ant-table-tbody"
      }, [rows]);
    }
  }, {
    key: "render",
    value: function render() {
      var h = arguments[0];
      var hasBody = this.hasBody,
          hasHead = this.hasHead,
          fixed = this.fixed,
          scroll = this.scroll,
          table = this.table;
      var tableStyle = {};

      if (!fixed && scroll.x) {
        var tableWidthScrollX = table.isAnyColumnsFixed ? 'max-content' : 'auto';
        tableWidthScrollX = scroll.x === true ? tableWidthScrollX : scroll.x;
        tableStyle.width = typeof tableWidthScrollX === 'number' ? "".concat(tableWidthScrollX, "px") : tableWidthScrollX;
      }

      if (fixed) {
        var width = this.tableBodyColumns.reduce(function (sum, _ref) {
          var w = _ref.width;
          return sum + parseFloat(w);
        }, 0);

        if (width > 0) {
          tableStyle.width = width + 'px';
        }
      }

      return h("table", {
        "class": scroll.x || fixed ? 'ant-table-fixed' : '',
        "style": tableStyle
      }, [h("col-group", {
        "attrs": {
          "columns": this.tableBodyColumns
        }
      }), hasHead && h("table-head", {
        "attrs": {
          "columns": this.columns,
          "fixed": fixed
        }
      }), hasBody && this.renderTableBody()]);
    }
  }]);
  return BaseTable;
}(_vuePropertyDecorator.Vue), _temp), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "table", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "fixed", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "hasHead", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "hasBody", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "scroll", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "footer", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
exports.BaseTable = BaseTable;